import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { LlmModelOptionsResponse } from '@/types/llmModels.ts';
import { LLM_MODEL_OPTIONS_KEY } from '@/utils/queryKeys.ts';
import { get_llm_model_options_url } from '@/utils/urls.ts';

type UseRetrieveLlmModelOptionsParams = {
  enabled?: boolean;
};

const useRetrieveLlmModelOptions = ({
  enabled = true,
}: UseRetrieveLlmModelOptionsParams = {}): UseQueryResult<LlmModelOptionsResponse, AxiosError> => {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: LLM_MODEL_OPTIONS_KEY,
    queryFn: async () => {
      const response = await apiClient.get<LlmModelOptionsResponse>(get_llm_model_options_url());
      return response.data;
    },
    enabled,
    staleTime: 30 * 60 * 1000,
  });
};

export default useRetrieveLlmModelOptions;
